"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _createIconComponent = _interopRequireDefault(require("./utils/createIconComponent"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var IconUserGroup = (0, _createIconComponent["default"])({
  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
    d: "M9.64 17.13a9 9 0 0 0 13.69 7.78 12.3 12.3 0 0 1 4.42-7.49v-.28a9.06 9.06 0 0 0-18.12 0zm9.06-6.46A6.44 6.44 0 0 1 25.07 16v.26l-.18.18a14.93 14.93 0 0 0-3.8 6.44l-.07.25-.24.09a6.35 6.35 0 0 1-2.11.36 6.46 6.46 0 1 1 0-12.92zM47.72 25.45a9.06 9.06 0 1 0 3.57-17.38 9.1 9.1 0 0 0-9 8.65 12.26 12.26 0 0 1 5.43 8.73zm-2.59-10.22a6.45 6.45 0 1 1 6.16 8.36 6.41 6.41 0 0 1-1-.07l-.29-.06-.08-.31a14.79 14.79 0 0 0-4.63-7.39l-.29-.22zM26.42 27a9.06 9.06 0 1 0 9.06-9.06A9.07 9.07 0 0 0 26.42 27zm9.06-6.46A6.46 6.46 0 1 1 29 27a6.46 6.46 0 0 1 6.48-6.45zM55.35 27.85h-7.57a12.22 12.22 0 0 1-3.2 7.48 15.12 15.12 0 0 1 10 14.14V52c7.56-.37 11.92-2.53 12.1-2.62l.43-.22v-9.58a11.75 11.75 0 0 0-11.76-11.73zm9.14 19.64l-.33.12a30.72 30.72 0 0 1-6.46 1.51l-.54.07v-.54a17.71 17.71 0 0 0-8.23-14.08l-.39-.25.21-.41a14.77 14.77 0 0 0 1.19-3.09l.1-.37h5.33a9.15 9.15 0 0 1 9.14 9.14z"
  }), _react["default"].createElement("path", {
    d: "M39.53 37.71h-8.11a11.75 11.75 0 0 0-11.74 11.74v9.7l.36.11a55.46 55.46 0 0 0 16.49 2.66c9 0 14.09-2.57 14.3-2.67l.43-.22v-9.58a11.75 11.75 0 0 0-11.73-11.74zm9.14 19.64l-.33.12a35.29 35.29 0 0 1-11.8 1.85 51.87 51.87 0 0 1-13.89-2l-.37-.1v-7.77a9.15 9.15 0 0 1 9.14-9.14h8.11a9.15 9.15 0 0 1 9.14 9.14z"
  }), _react["default"].createElement("path", {
    d: "M26.38 35.33a12.24 12.24 0 0 1-3.19-7.47h-8.54A11.75 11.75 0 0 0 2.91 39.58v9.7l.36.11a57.4 57.4 0 0 0 13.13 2.54v-2.46a15.12 15.12 0 0 1 9.98-14.14zm-12.55 13.2v.54l-.57-.07a56 56 0 0 1-7.38-1.54l-.37-.1v-7.78a9.15 9.15 0 0 1 9.14-9.14h6.29l.1.37a14.82 14.82 0 0 0 1.19 3.09l.21.41-.39.25a17.72 17.72 0 0 0-8.22 13.97z"
  })),
  height: undefined,
  width: undefined
});
IconUserGroup.displayName = 'IconUserGroup';
var _default = IconUserGroup;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@tecuity/sos-icons/react/user-group.js
// module id = 340
// module chunks = 0